module.exports = __webpack_public_path__ + "static/media/how-we-work-3-decor.78ae7120.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/general/how-we-work-3-decor.svg
// module id = 323
// module chunks = 0